module.exports = __webpack_public_path__ + "7c318c40e9883c5138afee64d7b94656.png";